import React from 'react';
import { Box, Card, Grid, Typography } from '@material-ui/core';
import { ViewStream } from '@material-ui/icons';
import { HoverText } from '@campfire/hover-link';
import { useFormBuilderDialogContext, RepeatableGroupFormItemData } from '../FormBuilderDialogContext';
import { useCampfireTheme } from '../../../../../theme/useCampfireTheme';

interface Props {
  data: RepeatableGroupFormItemData;
}

export const RepeatableGroupFormItem = (props: Props) => {
  const { data } = props;
  const { editRepeatableGroup, addField } = useFormBuilderDialogContext();
  const { theme } = useCampfireTheme();

  return (
    <Card
      elevation={0}
      style={{
        padding: 16,
        marginBottom: 0,
        width: '100%',
        border: `1px solid ${theme.color.grey.border}`,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      }}
    >
      <Grid container spacing={1} style={{ padding: 8 }}>
        <Grid item container spacing={1} xs alignItems='center'>
          <Grid item>
            <ViewStream style={{ color: theme.palette.text.secondary }} fontSize='small' />
          </Grid>
          <Grid item container xs>
            <Typography display='inline' style={{ fontWeight: 'bold' }}>
              {data.title || data.label || 'Repeatable Section'}
            </Typography>
          </Grid>
        </Grid>

        <HoverText color='primary' onClick={() => editRepeatableGroup(data)}>
          Edit Section
        </HoverText>

        <Grid item xs={12}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography color='textSecondary' variant='body2'>
              {data.minInstances}&ndash;{data.maxInstances} instances
              {data.askForCount ? ' · asks how many first' : ''}
            </Typography>
            <HoverText
              color='primary'
              variant='body2'
              onClick={() => addField(data.formItemId)}
              style={{ fontSize: '0.75rem' }}
            >
              + Add field
            </HoverText>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
};
